import React, { Children, useEffect, useState } from 'react'
import Header from './Header'
import { UiComponents, initialize } from "@simulanisindia/ui";
import { applicationId } from './../../env';
import { useDispatch } from "react-redux";
import { saveboardSearch } from "../../store/slice/boardSlice";

const DefaultLayout = ({children}) => {
  const { Header } = UiComponents;

// Search 
  const [inputValue, setInputValue] = useState("");
  const dispatch = useDispatch();
  const handleChange = (e) => {
    setInputValue(e.target.value);
    dispatch(saveboardSearch(e.target.value));
  };


  useEffect(() => {
    // initialize("6ceadf8c-c29f-4ae8-a6d6-761850c1ba7a", "token");
    initialize(applicationId, "token");
  }, []);

  return (
    <>
      {/* <Header/> */}
      <div className="main-head-parent">
        <Header
          showSearch={true}
          showDrawer={true}
          searchProps={{
            placeholder: "Search...",
            type: "text",
            className: "form-control",
            autoComplete: "off",
            value: inputValue,
            onChange: handleChange,
          }}
        />
      </div>

      <div className="bodynside">{children}</div>
    </>
  );
}

export default DefaultLayout